<div class="d-flex align-items-center" [ngClass]="{'sectionHeader': headerSize === 'h2'}">
  <mat-icon class="mr-2 icon--large" [svgIcon]="svgIcon"></mat-icon>
  <div data-testId="header-name" class="mb-0" [ngClass]="headerSize">{{title}}</div>
</div>
